import React from "react";
import { App } from "antd";
import { Route, Routes, Navigate, useNavigate } from "react-router-dom";
import {
  ControllerHomeScreen,
  DocControllerHomeScreen,
  DocContentsScreen,
  DocPresentationsScreen,
  DocVariablesScreen,
  DocArchievesScreen,
  DocContentsNewScreen,
  EducatorControllerHomeScreen,
  EducatorCircularListScreen,
  EducatorNewCircularScreen,
  EducatorEvaluationListScreen,
  EducatorNewEvaluationScreen,
  EducatorLearningListScreen,
  EducatorNewLearningScreen,
  ContinuerControllerHomeScreen,
  ContinuerControllerBluePrintScreen,
  ContinuerControllerNewBluePrintScreen,
  CentralControllerGuideScreen,
  CentralControllerHomeScreen,
  CreateNewGuideScreen,
  ArcControllerHomeScreen,
  CreateNewTaskScreen,
  ArcControllerTaskScreen,
  AllOrgDocumentsScreen,
  useHeaderNavItems,
  MitigatorListHomeScreen,
  MitigatorRiskHomeScreen,
  MitigatorSourceTrackerScreen,
  MitigatorThreatTrackerScreen,
  MitigatorThreatTypeTrackerScreen,
  MitigatorVulnerabilityTrackerScreen,
  MitigatorAssetTrackerScreen,
  MitigatorRatingTrackerScreen,
  MitigatorReferenceTrackerScreen,
  MitigatorRiskTrackerScreen,
  CreateNewRisk,
  AuditorControllerHomeScreen,
  CreateNewAuditBlueprintScreen,
  AuditorControllerBlueprintScreen,
  ViewAuditBlueprintScreen,
  AuditReportBlurprintTrackerScreem,
  AuditReportBluprintCreateScreen,
} from "../screens";
import {
  NMHomeScreen,
  NMLoginScreen,
  NMPageNotFoundPage,
  NMModuleRestrictedPage,
} from "@neumetric/blueprint-lib/pages";

const LOGIN_ENDPOINT = process.env.REACT_APP_LOGIN_ENDPOINT;
const DOMAIN = process.env.REACT_APP_MAIN_DOMAIN;
const ENVIRNOMENT_ID = process.env.REACT_APP_ENVIRNOMENT_ID;
const ENVIRNOMENT_TITLE = process.env.REACT_APP_ENVIRNOMENT_TITLE;
const ModuleID = "controller";
const Environment = { id: ENVIRNOMENT_ID, title: ENVIRNOMENT_TITLE };

const DocBlueprintRouter = (props) => {
  const { type } = props;
  return (
    <Routes>
      <Route
        path=""
        index
        element={<DocContentsNewScreen readOnly type={type} />}
      />
      <Route path="edit" element={<DocContentsNewScreen edit type={type} />} />
    </Routes>
  );
};
const DocContentRouter = (props) => {
  return (
    <Routes>
      <Route
        path="new"
        element={<DocContentsNewScreen type="content" create />}
      />
      <Route
        path=":blueprintId/*"
        element={<DocBlueprintRouter type="content" />}
      />
      <Route path="/" index element={<DocContentsScreen />} />
    </Routes>
  );
};
const OrgDocumentRouter = (props) => {
  return (
    <Routes>
      <Route path="/" index element={<AllOrgDocumentsScreen />} />
    </Routes>
  );
};
const DocPresentationRouter = (props) => {
  return (
    <Routes>
      <Route
        path="new"
        element={<DocContentsNewScreen type="presentation" create />}
      />
      <Route
        path=":blueprintId/*"
        element={<DocBlueprintRouter type="presentation" />}
      />
      <Route path="/" index element={<DocPresentationsScreen />} />
    </Routes>
  );
};
const DocumentControllerRouter = () => {
  return (
    <DocControllerHomeScreen>
      <Routes>
        <Route path="O/*" element={<OrgDocumentRouter />} />
        <Route path="C/*" element={<DocContentRouter />} />
        <Route path="P/*" element={<DocPresentationRouter />} />
        <Route path="V" element={<DocVariablesScreen />} />
        <Route path="A" element={<DocArchievesScreen />} />
        <Route path="A/:blueprintId" element={<DocBlueprintRouter />} />
        <Route path="/" index element={<Navigate replace to="C" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </DocControllerHomeScreen>
  );
};
const EduCircularRouter = (props) => {
  return (
    <Routes>
      <Route path="new" element={<EducatorNewCircularScreen />} />
      <Route
        path=":circularId/edit"
        element={<EducatorNewCircularScreen isEdit />}
      />
      <Route path="/" index element={<EducatorCircularListScreen />} />
    </Routes>
  );
};
const EduLearningRouter = (props) => {
  return (
    <Routes>
      <Route path="new" element={<EducatorNewLearningScreen />} />
      <Route
        path=":learnId/edit"
        element={<EducatorNewLearningScreen isEdit />}
      />
      <Route path="/" index element={<EducatorLearningListScreen />} />
    </Routes>
  );
};
const EduEvaluationRouter = (props) => {
  return (
    <Routes>
      <Route path="new" element={<EducatorNewEvaluationScreen />} />
      <Route
        path=":asmtId/edit"
        element={<EducatorNewEvaluationScreen isEdit />}
      />
      <Route path="/" index element={<EducatorEvaluationListScreen />} />
    </Routes>
  );
};

const EducatorControllerRouter = (props) => {
  return (
    <EducatorControllerHomeScreen>
      <Routes>
        <Route path="C/*" element={<EduCircularRouter />} />
        <Route path="L/*" element={<EduLearningRouter />} />
        <Route path="A/*" element={<EduEvaluationRouter />} />
        <Route path="/" index element={<Navigate replace to="L" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </EducatorControllerHomeScreen>
  );
};

const ContinuerBluePrintRouter = (props) => {
  return (
    <Routes>
      <Route
        path=""
        index
        element={<ContinuerControllerNewBluePrintScreen readOnly />}
      />
      <Route
        path="edit"
        element={<ContinuerControllerNewBluePrintScreen edit />}
      />
    </Routes>
  );
};

const ContinuerControllerRouter = (props) => {
  return (
    <ContinuerControllerHomeScreen>
      <Routes>
        <Route
          path="new"
          element={<ContinuerControllerNewBluePrintScreen create />}
        />
        <Route path=":blueprintId/*" element={<ContinuerBluePrintRouter />} />
        <Route path="/" element={<ContinuerControllerBluePrintScreen />} />
        <Route path="" element={<Navigate replace to="/" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </ContinuerControllerHomeScreen>
  );
};
const CentralControllerRouter = (props) => {
  return (
    <CentralControllerHomeScreen>
      <Routes>
        <Route path="new" element={<CreateNewGuideScreen create />} />
        <Route path=":guideId/*" element={<CentralGuideRouter />} />
        <Route path="/" element={<CentralControllerGuideScreen />} />
        <Route path="" element={<Navigate replace to="/" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </CentralControllerHomeScreen>
  );
};
const CentralGuideRouter = (props) => {
  return (
    <Routes>
      <Route path="" index element={<CreateNewGuideScreen readOnly />} />
      <Route path="edit" element={<CreateNewGuideScreen edit />} />
    </Routes>
  );
};
const RemediatorControllerRouter = (props) => {
  return (
    <ArcControllerHomeScreen>
      <Routes>
        <Route path="new" element={<CreateNewTaskScreen create />} />
        <Route path=":taskId/*" element={<ArcTaskRouter />} />
        <Route path="/" element={<ArcControllerTaskScreen />} />
        <Route path="" element={<Navigate replace to="/" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </ArcControllerHomeScreen>
  );
};

const ArcTaskRouter = (props) => {
  return (
    <Routes>
      <Route path="" index element={<CreateNewTaskScreen readOnly />} />
      <Route path="edit" element={<CreateNewTaskScreen edit />} />
    </Routes>
  );
};

const MitigatorListRouter = (props) => {
  return (
    <MitigatorListHomeScreen>
      <Routes>
        <Route path="S" element={<MitigatorSourceTrackerScreen />} />
        <Route path="T" element={<MitigatorThreatTrackerScreen />} />
        <Route path="Y" element={<MitigatorThreatTypeTrackerScreen />} />
        <Route path="V" element={<MitigatorVulnerabilityTrackerScreen />} />
        <Route path="A" element={<MitigatorAssetTrackerScreen />} />
        <Route path="R" element={<MitigatorRatingTrackerScreen />} />
        <Route path="Ref" element={<MitigatorReferenceTrackerScreen />} />
        <Route path="/" element={<Navigate replace to="S" />} />
        <Route path="" element={<Navigate replace to="/" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </MitigatorListHomeScreen>
  );
};

const MitigatorRiskRouter = () => {
  return (
    <MitigatorRiskHomeScreen>
      <Routes>
        <Route path="/" element={<MitigatorRiskTrackerScreen />} />
        <Route path="new" element={<CreateNewRisk />} />
        <Route path=":riskId" element={<CreateNewRisk />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </MitigatorRiskHomeScreen>
  );
};
const MitigatorControllerRouter = () => {
  return (
    <Routes>
      <Route path="L/*" element={<MitigatorListRouter />} />
      <Route path="R/*" element={<MitigatorRiskRouter />} />
      <Route path="/" element={<Navigate replace to="L" />} />
      <Route path="" element={<Navigate replace to="/" />} />
      <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
    </Routes>
  );
};

const AuditorControllerRouter = () => {
  return (
    <AuditorControllerHomeScreen>
      <Routes>
        <Route
          path="M/new"
          element={<CreateNewAuditBlueprintScreen create />}
        />
        <Route path="M/:blueprintId/*" element={<AuditorBlueprintRouter />} />
        <Route path="M" element={<AuditorControllerBlueprintScreen />} />
        <Route path="R" element={<AuditReportBlurprintTrackerScreem />} />
        <Route
          path="R/new"
          element={<AuditReportBluprintCreateScreen create />}
        />
        <Route
          path="R/:blueprintId"
          element={<AuditReportBluprintCreateScreen />}
        />
        <Route path="/" element={<Navigate replace to="M" />} />
        <Route path="" element={<Navigate replace to="/" />} />
        <Route path="/*" element={<Navigate replace to="/page-not-found" />} />
      </Routes>
    </AuditorControllerHomeScreen>
  );
};

const AuditorBlueprintRouter = () => {
  return (
    <Routes>
      {/*/A/:blueprintId */}
      <Route index element={<ViewAuditBlueprintScreen />} />

      {/*/A/:blueprintId/edit */}
      <Route path="edit" element={<CreateNewAuditBlueprintScreen edit />} />

      <Route path="*" element={<Navigate replace to="/page-not-found" />} />
    </Routes>
  );
};

const MainRouter = () => {
  const context = App.useApp();
  const { navigation } = useHeaderNavItems();
  return (
    <NMHomeScreen
      appContext={context}
      environment={Environment}
      domain={DOMAIN}
      moduleId={ModuleID}
      navigation={navigation}
      loginEndpoint={LOGIN_ENDPOINT}
    >
      <ControllerHomeScreen>
        <Routes>
          <Route path="/D/*" index element={<DocumentControllerRouter />} />
          <Route path="/E/*" index element={<EducatorControllerRouter />} />
          <Route path="/C/*" index element={<ContinuerControllerRouter />} />
          <Route path="/G/*" index element={<CentralControllerRouter />} />
          <Route path="/R/*" index element={<RemediatorControllerRouter />} />
          <Route path="/M/*" index element={<MitigatorControllerRouter />} />
          <Route path="/A/*" index element={<AuditorControllerRouter />} />
          <Route path="/" element={<Navigate replace to="/G" />} />
          <Route path="" element={<Navigate replace to="/" />} />
          <Route
            path="/*"
            element={<Navigate replace to="/page-not-found" />}
          />
        </Routes>
      </ControllerHomeScreen>
    </NMHomeScreen>
  );
};

const LogInWrapper = () => {
  const navigate = useNavigate();
  return (
    <NMLoginScreen
      onNavigate={(path) => navigate(path)}
      moduleId={ModuleID}
      environment={Environment}
    />
  );
};

function AppRouter() {
  const navigate = useNavigate();
  return (
    <Routes>
      <Route path="/login" element={<LogInWrapper />} exact />
      <Route
        path="/page-not-found"
        element={
          <NMPageNotFoundPage
            domain={DOMAIN}
            onNavigate={(path) => navigate(path)}
          />
        }
        exact
      />
      <Route
        path="/module-restricted"
        element={
          <NMModuleRestrictedPage
            authLink={LOGIN_ENDPOINT}
            onNavigate={(path) => navigate(path)}
          />
        }
        exact
      />
      <Route path="/*" element={<MainRouter />} />
    </Routes>
  );
}

export default AppRouter;
